import "font-awesome/css/font-awesome.min.css";

import React, { Component } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

import { connect } from "react-redux";

import { CSSTransition, TransitionGroup } from "react-transition-group";

import SingleChoice from "./ComponentV10/SingleChoice";
import MultipleChoice from "./ComponentV10/MultipleChoice";
import TextBox from "./ComponentV10/TextBox";
import MultiLineText from "./ComponentV10/MultiLineText";
import RatingScale from "./ComponentV10/RatingScale";
import NPS from "./ComponentV10/NPS";
import NPSV2 from "./ComponentV10/NPSV2";
import Email from "./ComponentV10/Email";
import Number from "./ComponentV10/Number";
import Dropdown from "./ComponentV10/Dropdown";
import YesNo from "./ComponentV10/YesNo";
import Date from "./ComponentV10/Date";
import Summary from "./Summary/Summary";

import { assessmentActions, questionsActions } from "../../../_actions";

import QuestionHeader from "../Component/QuestionHeader";

import LogoAssessmentHeader from "../Component/LogoAssessmentHeader";

import FeedbackModal from "./FeedbackModal";

import AssessmentReport from "../Component/AssessmentReport/AssessmentReport";

import AssessmentSummary from "../Component/AssessmentSummary/AssessmentSummary";

import moment from "moment";

import LanguageComponent from "./../Component/LanguageComponent";
import LeadershipReport from "../Component/LeadershipReport/LeadershipReport";
import { getQuestionPair, reverseFn } from "../../Surveylink/FunctionLibrary/FuntionList";



class QuestionPublish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisableSubmit: false,

      SurveyCode: this.props.codeValue,

      radioButton: false,
      radioButton2: false,
      currQues: null,
      showWelcomeScreen: true,
      showQuestionScreen: false,
      showThankyouScreen: false,
      instructionPage: false,
      showRedFlag: false,
      saveMsg: "",
      CurrQuesIndex: 1,
      submitSucces: false,

      surveyLanguageName: "English",
      ShowSubmitButton: false,

      CurrPairIndex: 1,

      textAnswer: "",
      unattemptList: [],
      changeType: "fade",
      mandatoryOn: false,
      afterSubmitData: {
        thankyouText: "",
        bgColor: "",
        bgImage: "",
        textColor: "",
        logo: "",
      },
      alreadySubmitted: false,
      clicked: false,

      showDropdownQues: false,
      dropdownInput: "",
      scrollPosition: 0,
      IpObj: {},
      ShowNotAttempted: false,
      submitMandatory: "",
      setTimeoutRef: "",
      setTimeoutInit: 0,
      disableTimer: false,
      timeCounter: 0,
      setIntervalRef: "",
      showLeaderReportModal: false,

      showReportModal: false,
      showSummaryReport: false,
      showViewReportThankYouButton: false,
      surveyLanguageCode: '',

      themeType: 2,



      showNameEditScreen: false,
      nameFormData: {
        'name': '',
        'email': ''
      },
      errNameForm: {
        'name': '',
        'email': ''
      },


      backSummary: false,
      showMainSummaryModal: false,
      crrDetail: "",
      crrCodeUserDetails: {
        "employeeId": "",
        "name": "",
        "email": "",
        "mobile": "",
        "message": ""
      },
      topFiveTalent: true,
      contactExpertSection: false,
      showMyExpertList: false,
      submitBlock: false


    };


    this.handleShowMainSummaryModal = this.handleShowMainSummaryModal.bind(this);
    this.handleShowMainSummaryModalBack = this.handleShowMainSummaryModalBack.bind(this);
    this.handleExpertContactModalBack = this.handleExpertContactModalBack.bind(this);
    this.handleExpertContactModal = this.handleExpertContactModal.bind(this);
    this.handleInputExpertForm = this.handleInputExpertForm.bind(this);
    this.bookExpert = this.bookExpert.bind(this);
    this.handleExpertClick = this.handleExpertClick.bind(this);


  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());
    this.props.dispatch(questionsActions.getParameterCategory({ type: 0 }));

    // const getData = async () => {
    //   const res = await axios.get('https://geolocation-db.com/json/')
    //   this.setState({IpObj:res.data})
    //   return(res.data)
    // }
    // getData();


    this.props.dispatch(questionsActions.getAssessmentReport({
      "surveyModule": 11
    }));

    this.props.dispatch(questionsActions.getAssessmenrEmployeeDetails({}));
    this.props.dispatch(questionsActions.getAssessmentStatus({
      "surveyModule": 11
    }));

    this.props.dispatch(questionsActions.getAssessmentQuestionList({
      "surveyType": "LEADERSHIP"
    }, "v4"));



    this.props.dispatch(questionsActions.getLanguageLabel());

    this.props.dispatch(questionsActions.getTranslateElementAll());


  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  prevQues = () => {
    this.setState({ changeType: "fade1" });
    this.setState({ ShowSubmitButton: false });
    this.setState({ submitMandatory: "" });

    let { questions } = this.props;
    let { questionsList } = questions;

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 1 && CurrQuesIndex < questionsList.length + 1) {
        CurrQuesIndex = CurrQuesIndex - 1;

        this.setState({ CurrQuesIndex }, () => {
          // this.handleSubmitAppear();
        });
      } else {
        this.setState({
          showWelcomeScreen: false,
          showQuestionScreen: false,
          showThankyouScreen: false,
          instructionPage: true,
        });
      }
    }

    // console.log("answersList: ", answersList)
  };

  nextPairQues = (pairList) => {
    console.log("Next Pair!");
    window.scrollTo(0, 0);
    this.setState({ changeType: "fade", clicked: "" }, () => {
      if (pairList && pairList.length > 0) {
        let { CurrPairIndex } = this.state;
        if (CurrPairIndex > 0 && CurrPairIndex < pairList.length) {
          this.setState({ CurrPairIndex: CurrPairIndex + 1 });
        }
      }
    })
  }


  nextQues = (type2) => {
    console.log("Next Question!");
    // clearTimeout(this.state.setTimeoutRef);
    // clearInterval(this.state.setIntervalRef);

    window.scrollTo(0, 0);

    this.setState({ changeType: "fade", clicked: "" }, () => {
      let { questions } = this.props;
      let { questionsList, surveyScreenData, GroupQuestionOnlyList } =
        questions;

      let { CurrQuesIndex } = this.state;

      // console.log("<---->------>2");

      let itemQ =
        questionsList && questionsList.length > 0
          ? questionsList[CurrQuesIndex]
          : {};

      //console.log("itemQ--" + (CurrQuesIndex + 1).toString() + "-->", itemQ);

      //---------------------------- basic ---------------------------------------
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];

      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex < questions.questionsList.length) {
          this.props.dispatch(
            questionsActions.handleRecordResTime(
              0,
              itemQ,
              AnswerListFinal,
              questionsList,
              surveyScreenData,
              GroupQuestionOnlyList
            )
          );
        }

        questionsList.forEach((ques) => {
          if (ques.templateId === 13) {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push({
                ...AnswerListFinal[getIndex],
                SubQuestionList: ques.SubQuestionList,
              });
            }
          } else {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push(AnswerListFinal[getIndex]);
            }
          }
        });
      }
      //-------------------------------------------------------------------
      let isFeedback = false;
      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
          //----------------latestcode ---------------------------
          //console.log("11111111111------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};
          let flag = 0;

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }

              if (item.isMandatory) {
                let template = item.template;

                if (
                  template === 1 ||
                  template === 3 ||
                  template === 4 ||
                  template === 5 ||
                  template === 6 ||
                  template === 16 ||
                  template === 11
                ) {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                } else if (template === 13) {
                  let isAllAnswered = 0;
                  if (
                    item &&
                    item.SubQuestionList &&
                    item.SubQuestionList.length > 0
                  ) {
                    item.SubQuestionList.forEach((subQues) => {
                      let getIndex2 = AnswerListFinal.findIndex(
                        (prev) => prev.questionId === subQues.id
                      );

                      if (getIndex2 !== -1) {
                        if (
                          AnswerListFinal &&
                          AnswerListFinal[getIndex2] &&
                          AnswerListFinal[getIndex2].multiAnswer &&
                          AnswerListFinal[getIndex2].multiAnswer.length > 1
                        ) {
                          isAllAnswered++;
                        }
                      }
                    });
                  }

                  if (item.SubQuestionList.length !== isAllAnswered) {
                    flag = flag + 1;
                  }
                } else if (template === 2) {
                  if (
                    !(item && item.multiAnswer && item.multiAnswer.length > 0)
                  ) {
                    flag = flag + 1;
                  }
                } else {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                }
              }
            }
          }

          if (!flag) {
            try {
              let cryptedText = CryptoJS.AES.encrypt(
                JSON.stringify(AnswerListFinal),
                "secretkey123"
              ).toString();
              localStorage.setItem("myAnswers", JSON.stringify(cryptedText));
            } catch (error) {
              console.log("not saved!");
            }

            //console.log("isFeedback----------->", isFeedback);

            if (isFeedback && type2 !== 2) {
              this.setState({ showFeedbackModal: true });
            } else {
              CurrQuesIndex = CurrQuesIndex + 1;

              this.setState({ CurrQuesIndex }, () => {
                this.setState({
                  ShowNotAttempted: false,
                  showFeedbackModal: false,
                });

                this.handleSubmitAppear();
              });
            }
          } else {
            this.setState({ ShowNotAttempted: true });
          }

          // console.log("CurrQuesIndex------>", CurrQuesIndex);
          // console.log("questionsList.length------>", questionsList.length);
          // console.log("itemQ------>", itemQ);

          // if (itemQ && itemQ.seconds && !this.state.disableTimer) {
          //   if (CurrQuesIndex < questionsList.length) {
          //     let setTimeoutRef = setTimeout(
          //       () => this.nextQues(),
          //       itemQ.seconds * 1000
          //     );
          //     this.setState(
          //       {
          //         timeCounter: itemQ.seconds,
          //         setTimeoutRef: setTimeoutRef,
          //         setTimeoutInit: moment().unix(),
          //       },
          //       () => {
          //         let setIntervalRef = setInterval(
          //           () =>
          //             this.setState({
          //               timeCounter:
          //                 this.state.timeCounter > 0
          //                   ? this.state.timeCounter - 1
          //                   : 0,
          //             }),
          //           1000
          //         );
          //         this.setState({ setIntervalRef: setIntervalRef });
          //       }
          //     );
          //   } else {
          //     let setTimeoutRef = setTimeout(
          //       () => this.saveAnswers(),
          //       itemQ.seconds * 1000
          //     );
          //     this.setState(
          //       {
          //         timeCounter: itemQ.seconds,
          //         setTimeoutRef: setTimeoutRef,
          //         setTimeoutInit: moment().unix(),
          //       },
          //       () => {
          //         let setIntervalRef = setInterval(
          //           () =>
          //             this.setState({
          //               timeCounter:
          //                 this.state.timeCounter > 0
          //                   ? this.state.timeCounter - 1
          //                   : 0,
          //             }),
          //           1000
          //         );
          //         this.setState({ setIntervalRef: setIntervalRef });
          //       }
          //     );
          //   }
          // }
        } else if (CurrQuesIndex === questionsList.length) {
          //console.log("222222222------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }
            }
          }

          if (isFeedback && type2 !== 2) {
            this.setState({ showFeedbackModal: true });
          }
        }
      }
    });
  };

  submitFeedback = () => {
    let { CurrQuesIndex } = this.state;

    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex === questionsList.length) {
        this.setState({ showFeedbackModal: false }, () => {
          this.handleSubmitAppear();
        });
      } else {
        CurrQuesIndex = CurrQuesIndex + 1;
        this.setState({ CurrQuesIndex }, () => {
          this.setState({ ShowNotAttempted: false, showFeedbackModal: false });
          this.handleSubmitAppear();
        });
      }
    }
  };

  closeFeedbackModal = () => {
    this.setState({ showFeedbackModal: false });
  };

  handleSubmitAppear = () => {
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;

    setTimeout(() => {
      if (
        questionsList &&
        questionsList.length > 0 &&
        questionsList.length === CurrQuesIndex
      ) {
        this.setState({ ShowSubmitButton: true });
      } else {
        this.setState({ ShowSubmitButton: false });
      }
    }, 300);
  };




  onSelectOption = (currentOption, pairList, pairIndex) => {

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;
    let quesId = currentOption.questionId;


    if (pairList && pairList.length > 0) {
      if (pairList && pairList[pairIndex] && pairList[pairIndex]["quesList"].length > 0) {
        let getIndex = pairList[pairIndex]["quesList"].findIndex(prev => prev.id !== quesId);
        if (getIndex !== -1) {
          let secondQuesId = pairList[pairIndex]["quesList"][getIndex]["id"];
          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(prev => prev.questionId === secondQuesId);
            if (getIndex2 !== -1) {

              this.props.dispatch(
                questionsActions.handlePairPreChange(
                  secondQuesId,
                  "",
                  questionsList,
                  answersList,
                  surveyScreenData,
                  GroupQuestionOnlyList
                )
              );


            }
          }
        }
      }
    }




    this.props.dispatch(
      questionsActions.handlePairPreChange(
        quesId,
        currentOption,
        questionsList,
        answersList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // setTimeout(() => this.nextPairQues(pairList), 300);

  }



  handleRadio = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let { CurrQuesIndex } = this.state;

    if (this.state.radioButton === currentOption.id) {
      this.setState({ radioButton: null });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          "",
          0,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    } else {
      // console.log("currentOption----------------------IIIIIIIIIIIIIIIIIIIIIIIII--------------------->",currentOption)
      this.setState({ radioButton: currentOption.id });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          Index,
          GroupQuestionOnlyList
        )
      );
    }

    this.setState({ radioButton: null });

    // if(!ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    // setTimeout(()=>this.checkFeedback(), 300);

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // console.log("-----questionsListlength---->", questionsList.length);
    // console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        // clearTimeout(this.state.setTimeoutRef);
        // clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        // clearTimeout(this.state.setTimeoutRef);
        // clearInterval(this.state.setIntervalRef);
      }
    }

    setTimeout(() => this.nextQues(), 300);
  };


  handleCheckInput = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    if (true) {
      this.setState({ radioButton: currentOption.id });
      // console.log("currentOption::", currentOption)
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    }

    // setTimeout(()=>this.nextQues(), 300);
  };

  goToInstructionPage = () => {
    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData.isInstruction) {
      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: true,
      });
    } else {
      let { questionsList } = questions;
      let itemQ =
        questionsList && questionsList.length > 0 ? questionsList[0] : {};
      //console.log("itemQ--01-->", itemQ);

      // if (itemQ && itemQ.seconds && !this.state.disableTimer) {
      //   let setTimeoutRef = setTimeout(
      //     () => this.nextQues(),
      //     itemQ.seconds * 1000
      //   );
      //   this.setState(
      //     {
      //       timeCounter: itemQ.seconds,
      //       setTimeoutRef: setTimeoutRef,
      //       setTimeoutInit: moment().unix(),
      //     },
      //     () => {
      //       let setIntervalRef = setInterval(
      //         () =>
      //           this.setState({
      //             timeCounter:
      //               this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
      //           }),
      //         1000
      //       );
      //       this.setState({ setIntervalRef: setIntervalRef });
      //     }
      //   );
      // }

      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: true,
        showThankyouScreen: false,
        instructionPage: false,
      });
    }
    window.scrollTo(0, 0);
  };

  goToQuestionPage = () => {
    let { questions } = this.props;
    let { questionsList } = questions;
    let itemQ =
      questionsList && questionsList.length > 0 ? questionsList[0] : {};

    // if (itemQ && itemQ.seconds && !this.state.disableTimer) {
    //   let setTimeoutRef = setTimeout(
    //     () => this.nextQues(),
    //     itemQ.seconds * 1000
    //   );
    //   this.setState(
    //     {
    //       timeCounter: itemQ.seconds,
    //       setTimeoutRef: setTimeoutRef,
    //       setTimeoutInit: moment().unix(),
    //     },
    //     () => {
    //       let setIntervalRef = setInterval(
    //         () =>
    //           this.setState({
    //             timeCounter:
    //               this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
    //           }),
    //         1000
    //       );
    //       this.setState({ setIntervalRef: setIntervalRef });
    //     }
    //   );
    // }

    this.setState({
      showWelcomeScreen: false,
      showQuestionScreen: true,
      showThankyouScreen: false,
      instructionPage: false,
    });
    window.scrollTo(0, 0);
  };

  submitPairQues = () => {

    setTimeout(() => {
      this.setState({ showViewReportThankYouButton: true });
    }, 3000)


    let { questions } = this.props;
    let { answersList } = questions;
    let survey = { code: this.state.SurveyCode };

    this.props.dispatch(
      questionsActions.saveAssessmentAnswers(
        answersList,
        survey,
        this.props,
        this.state.IpObj,
        true,
        11
      )
    );



  }


  saveAnswers() {

    this.setState({ submitBlock: true });

    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData) {
      this.setState({
        afterSubmitData: surveyScreenData,
      });
    }

    let survey = {
      code: this.state.SurveyCode,
    };

    //---------------------- new code ------------------------------------------

    let { questionsList } = questions;

    //---------------------------- basic ---------------------------------------
    let answersList = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];

    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }
    //-------------------------------------------------------------------

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      let flag = 0;
      // console.log(" CurrQuesIndex=====>: ",CurrQuesIndex," questionsList.length=====>: ", questionsList.length)

      if (CurrQuesIndex > 0 && CurrQuesIndex <= questionsList.length) {
        //----------------latestcode ---------------------------

        let questionId =
          questionsList &&
            questionsList[CurrQuesIndex - 1] &&
            questionsList[CurrQuesIndex - 1].id
            ? questionsList[CurrQuesIndex - 1].id
            : "";

        if (answersList && answersList.length > 0) {
          let getIndex2 = answersList.findIndex(
            (prev) => prev.questionId === questionId
          );
          if (getIndex2 !== -1) {
            let item = answersList[getIndex2];

            if (item.isMandatory) {
              let template = item.template;

              if (
                template === 1 ||
                template === 3 ||
                template === 4 ||
                template === 5 ||
                template === 6 ||
                template === 16 ||
                template === 11
              ) {
                if (!item.answer) {
                  flag = flag + 1;
                }
                // console.log(" template: ",template," answer: ",item.answer," flag: ",flag)
              } else if (template === 13) {
                let isAllAnswered = 0;
                if (
                  item &&
                  item.SubQuestionList &&
                  item.SubQuestionList.length > 0
                ) {
                  item.SubQuestionList.forEach((subQues) => {
                    let getIndex2 = AnswerListFinal.findIndex(
                      (prev) => prev.questionId === subQues.id
                    );

                    if (getIndex2 !== -1) {
                      if (
                        AnswerListFinal &&
                        AnswerListFinal[getIndex2] &&
                        AnswerListFinal[getIndex2].multiAnswer &&
                        AnswerListFinal[getIndex2].multiAnswer.length > 1
                      ) {
                        isAllAnswered++;
                      }
                    }
                  });
                }

                if (item.SubQuestionList.length !== isAllAnswered) {
                  flag = flag + 1;
                }
              } else if (template === 2) {
                if (
                  !(item && item.multiAnswer && item.multiAnswer.length > 0)
                ) {
                  flag = flag + 1;
                }
              } else {
                if (!item.answer) {
                  flag = flag + 1;
                }
              }
            }
          }
        }

        // console.log("% ===============> flag1 ==================>",flag)
      }

      if (!flag) {
        if (!this.state.isDisableSubmit) {
          // clearTimeout(this.state.setTimeoutRef);
          // clearInterval(this.state.setIntervalRef);

          console.log("Answer Submitted!");

          setTimeout(() => {
            this.setState({ showViewReportThankYouButton: true });
          }, 3000)

          this.props.dispatch(
            questionsActions.saveAssessmentAnswers(
              AnswerListFinal,
              survey,
              this.props,
              this.state.IpObj,
              true,
              11
            )
          );
        }
        this.setState({ submitMandatory: "" });
      } else {
        this.setState({
          submitMandatory: "Please attempt mandatory question!",
        });
      }
    }

    // console.log("% ===============> answersList2 ==================>",answersList)
    // console.log("% ===============> answersList2 ==================>",answersList)
  }

  ansTextBoxClick(ques) {
    this.setState({ currQues: ques });
  }

  ansTextBoxChange1 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 1,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  handleFeedbackInput = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      name: e.target.value,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitFeedbackChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  ansNPSInput = (val, ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: val,
      ans: 1,
    };

    this.setState({ textAnswer: val });

    let { CurrQuesIndex } = this.state;

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
      console.log(
        "resTime----------------------resTime--------------------->",
        resTime
      );
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // console.log("-----questionsListlength---->", questionsList.length);
    // console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        // clearTimeout(this.state.setTimeoutRef);
        // clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        // clearTimeout(this.state.setTimeoutRef);
        // clearInterval(this.state.setIntervalRef);
      }
    }

    // if(!Ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    setTimeout(() => this.nextQues(), 300);
  };

  ansTextBoxChange2 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 2,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  clickOK = () => {
    // setTimeout(()=>this.nextQues(), 300);
    this.nextQues();
  };

  clickOKLast = (Ques) => {
    // console.log("clickOKLast; ")

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: "",
      ans: 3,
    };

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
        CurrQuesIndex = CurrQuesIndex + 1;

        this.setState({ CurrQuesIndex });
      }
    }

    let answersList2 = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];
    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }

    let flag = 0;
    let unattemptList = [];
    answersList2.forEach((item, index) => {
      if (item.isMandatory) {
        let template = item.template;

        if (
          template === 1 ||
          template === 3 ||
          template === 4 ||
          template === 5 ||
          template === 6 ||
          template === 16 ||
          template === 11
        ) {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else if (template === 13) {
          let isAllAnswered = 0;
          if (item && item.SubQuestionList && item.SubQuestionList.length > 0) {
            item.SubQuestionList.forEach((subQues) => {
              let getIndex2 = AnswerListFinal.findIndex(
                (prev) => prev.questionId === subQues.id
              );
              if (
                AnswerListFinal &&
                AnswerListFinal[getIndex2] &&
                AnswerListFinal[getIndex2].multiAnswer &&
                AnswerListFinal[getIndex2].multiAnswer.length > 1
              ) {
                isAllAnswered++;
              }
            });
            if (item.SubQuestionList.length !== isAllAnswered) {
              flag = flag + 1;
              unattemptList.push(index + 1);
            }
          }
        } else if (template === 2) {
          if (!(item && item.multiAnswer && item.multiAnswer.length > 0)) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        }
      }
    });

    // console.log("% ===============> answersList ==================>",answersList)

    if (flag) {
      this.setState({ unattemptList: unattemptList });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        if (this.state.unattemptList && this.state.unattemptList.length > 0) {
          // console.log("-----working x")
          this.setState({ CurrQuesIndex: unattemptList[0] });
          // console.log("-----working x 1")
        }
      }
    } else {
      this.setState({ unattemptList: [] });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        // console.log("All mandatory questions are attempted , now go to last question i.e. submit! ")
        this.setState({ CurrQuesIndex: questionsList.length });
      }
    }

    //nothing
  };

  onMandatoryAttempt = (elem) => {
    this.setState({ CurrQuesIndex: elem });
    this.setState({ mandatoryOn: true });
  };

  gotoSubmit = () => {
    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      this.setState({ CurrQuesIndex: questionsList.length });
    }
  };

  // handleLanguage = (e) => {
  //   if (e.target.value === "en") {
  //     this.setState({ surveyLanguageCode: "", surveyLanguageName: "" });
  //   } else {
  //     this.setState({
  //       surveyLanguageCode: e.target.value,
  //       surveyLanguageName: "",
  //     });
  //   }
  // };

  openDropdownQuestion = (check) => {
    this.setState({ showDropdownQues: check });
  };

  handleDropdownSelect = (value) => {
    this.setState({ dropdownInput: value, showDropdownQues: false });
  };

  handleMatrixRadio = (ques, subQues, currentOption, items) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let currIndex2 = answersList.findIndex(
      (element) => element.questionId === subQues.id
    );

    //console.log('------>answersList------>',answersList)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        currentOption,
        currentOption.weightage,
        surveyScreenData,
        subQues,
        GroupQuestionOnlyList
      )
    );

    // setTimeout(()=>this.nextQues(), 300);
  };

  handleReport = (type) => {
    console.log("----------type------------->", type)
    if (type === 2) {
      this.loadExpertData()

      let data10 = {
        "keyWord": "",
        "pageNo": 1,
        "size": 10000
      }
      this.props.dispatch(questionsActions.getParameterLibraryNameList(data10));

      this.props.dispatch(questionsActions.getLeadershipReportScore_USER({ "surveyModule": 11 }));
      this.props.dispatch(questionsActions.getLeadershipParaCategory_USER({}));
      this.props.dispatch(questionsActions.getLeadershipTextDetails_USER({}));

      this.setState({ showLeaderReportModal: true });
    } else {
      window.location.reload();
    }
  };

  handleSummaryReport = () => {
    this.props.dispatch(questionsActions.getAssessmentReport({}));
    this.setState({ showSummaryReport: true });
  }

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  closeSummaryReportModal = () => {
    this.setState({ showSummaryReport: false });
  };


  handleLanguage = (item, langList) => {
    console.log("item------------------->", item)
    if (item.shortName === 'en') {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: 'English', surveyLanguageRTL: false });
    }
    else {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: item.name, surveyLanguageRTL: item.isRTL });
    }
  }


  handleDownloadStatus = (reportType) => {
    let data = {
      moduleType: "ASSESSMENT"
    }
    this.props.dispatch(assessmentActions.assessmentDownloadStatus(data));
  }






  loadExpertData = () => {
    let { questions } = this.props;
    let { getAssessmenrEmployeeDetailsData } = questions;
    if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name && getAssessmenrEmployeeDetailsData.email) {
      let eleUser = getAssessmenrEmployeeDetailsData;
      let temp2 = {
        employeeId: eleUser.employeeId,
        name: eleUser.name,
        email: eleUser.email,
        emp_id: eleUser.emp_id,
        mobile: eleUser.mobile,
      };
      this.setState({ crrCodeUserDetails: temp2 });
    }

    // this.props.dispatch(assessmentActions.getExpertDetailsList());
    // this.props.dispatch(assessmentActions.getExpertOrderBookList());
  }



  handleShowMainSummaryModalBack() {

    this.setState({ showMainSummaryModal: true, showMyExpertList: false, backSummary: false });
  }

  handleShowMainSummaryModal(ele) {

    this.loadExpertData()
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({ showMainSummaryModal: false, backSummary: true, showMyExpertList: false, crrDetail: ele });
  }

  handleExpertContactModal(ele) {
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: ele, topFiveTalent: false
    });
  }

  handleExpertContactModalBack() {
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: false, topFiveTalent: true
    });
  }
  handleInputExpertForm(value, name) {
    let { crrCodeUserDetails } = this.state;
    crrCodeUserDetails[name] = value;
    this.setState({ crrCodeUserDetails });
  }

  bookExpert(userDetails, expertDetails) {
    let data = {
      "name": userDetails.name,
      "email": userDetails.email,
      "mobile": userDetails.mobile,
      "message": userDetails.message,
      "expertId": expertDetails.id,
    }
    console.log("--------->data<---------123123123131-------", data)

    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderPlace(data));

  }

  handleExpertClick() {
    const { history } = this.props;
    history.push('/assessment/expert'); // Replace '/expert-page' with the actual route of your expert page
  }

  viewMyExpert = () => {

    this.loadExpertData()
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({ backSummary: true, showMyExpertList: true })

  }


  closeLeaderReportModal = () => {
    this.setState({ showLeaderReportModal: false })
  }


  render() {
    let { questions, onLogout } = this.props;

    let {
      getParameterCategoryData,
      getAssessmentStatusData,
      getAssessmentReportByEmpIDData,
      getAssessmenrEmployeeDetailsData,
      questionsList,
      answersList,
      surveyStatus,
      GroupQuestionOnlyList,
      getRespondantNameData,
      getTranslateElementAllData,

      getLeadershipReportScore_USERData,
      getLeadershipParaCategory_USERData,
      getLeadershipTextDetails_USERData

    } = questions;

    let check =
      getAssessmentStatusData && getAssessmentStatusData.check
        ? getAssessmentStatusData.check
        : 0;

    let createdAt =
      getAssessmentStatusData && getAssessmentStatusData.createdAt
        ? moment(new Date(parseInt(getAssessmentStatusData.createdAt))).utcOffset("+05:30").format("DD MMMM, YYYY")
        : "";


    function getLastLabel(list) {
      let value = ""
      if (list && list.length > 0) {
        let new_list_2 = list.filter(prev => prev.isComplete === true);
        if (new_list_2 && new_list_2.length > 0) {
          value = new_list_2[new_list_2.length - 1]["name"]
        } else {
          value = list[0]["name"];
        }
      }
      return value ? "LEADING " + value : ""
    }


    let {
      timeCounter,
      setTimeoutInit,
      showFeedbackModal,
      CurrQuesIndex,
      afterSubmitData,
      clicked,
      showDropdownQues,
      IpObj,
      ShowNotAttempted,
      submitMandatory,
      showViewReportThankYouButton,
      showSummaryReport,
      themeType,

      submitBlock,
      showLeaderReportModal,
      CurrPairIndex

    } = this.state;



    let { UserRespondantName } = this.props;

    let { showReportModal, surveyLanguageCode, surveyLanguageName } = this.state;

    const isMobile = window.innerWidth <= 700;

    //console.log('isMobile: ',isMobile)

    // console.log(
    //   "setTimeoutInit:---------------------------------> ",
    //   this.state.setTimeoutInit
    // );
    console.log("CurrPairIndex:---------------------------------> ", CurrPairIndex)
    // console.log("surveyScreenData:---------------------------------> ", surveyScreenData)
    // console.log("surveyStatus:---------------------------------> ", surveyStatus)

    let surveyScreenData = {};
    if (questions.surveyScreenData) {
      surveyScreenData = { ...questions.surveyScreenData };
      // surveyScreenData["name"] = "UMatter - Employee Engagement Survey";
      // surveyScreenData["logo"] = "img/companylogo/kotaklogo.png";
      // surveyScreenData["logo2"] = "img/companylogo/umatters.png";

      // if(isMobile){
      //   surveyScreenData["logo2"] = "img/companylogo/kotaklogo2.png";
      // }
      // else{
      //   surveyScreenData["logo2"] = "img/companylogo/kotakbanner.png";
      // }

      // surveyScreenData["logo"] = "img/companylogo/umatters.png";
    }

    let bgImage = "";
    let bgColor = "";
    if (surveyScreenData && surveyScreenData.bgImage) {
      bgImage = "url(" + surveyScreenData.bgImage + ")";
    }

    if (surveyScreenData && surveyScreenData.bgColor) {
      bgColor = surveyScreenData.bgColor;
    }

    // console.log("CurrQuesIndex: ", CurrQuesIndex);

    // console.log("showQuestionScreen: ", this.state.showQuestionScreen);
    // console.log("showWelcomeScreen: ", this.state.showWelcomeScreen);
    // console.log("showThankyouScreen: ", this.state.showThankyouScreen);

    let welcomeTextDislay = [];
    let instructionTextDislay = [];

    if (surveyScreenData && surveyScreenData.welcomeText) {
      welcomeTextDislay = surveyScreenData.welcomeText;
      instructionTextDislay = surveyScreenData.instructionText;
    }

    //console.log("welcomeTextDislay: ", welcomeTextDislay);

    let surveytitle = "";
    let bgType = "";

    if (surveyScreenData && surveyScreenData.name) {
      surveytitle = surveyScreenData.name;
      bgType = surveyScreenData.bgType;
    }
    // console.log("this.state.unattemptList : ", this.state.unattemptList );

    let LabelObj = questions.getLanguageLabelData;
    //console.log("surveyScreenData: ", surveyScreenData);

    //console.log("afterSubmitData: ", afterSubmitData);

    //console.log("surveyStatus: ", surveyStatus);

    let LanguageList = questions.langList;
    //console.log("LanguageList: ", LanguageList);

    //console.log("surveyScreenData: ", surveyScreenData);

    function showRadioMatrix(SubQues, option) {
      let getIndex1 = answersList.findIndex(
        (prev) => prev.questionId === SubQues.id
      );
      let getIndex4 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionHead === option.heading
      );
      let getIndex3 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionId === option.id
      );

      if (getIndex4 !== -1) {
        if (getIndex3 !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function FormatMatriXOptionHeading(question, isOption) {
      let paraObjShow = {};
      if (question && question.optionsList && question.optionsList.length > 0) {
        question.optionsList.forEach((item) => {
          if (paraObjShow && paraObjShow[item.heading]) {
            paraObjShow[item.heading] += 1;
          } else {
            paraObjShow[item.heading] = 1;
          }
        });
      }

      let headingList = [];
      let tempKey = Object.keys(paraObjShow);
      if (tempKey && tempKey.length > 0) {
        tempKey.forEach((item) => {
          headingList.push({
            name: item,
            span: paraObjShow[item],
          });
        });
      }

      if (isOption) {
        let OptionList = [];
        if (headingList && headingList.length > 0) {
          headingList.forEach((heading) => {
            if (
              question &&
              question.optionsList &&
              question.optionsList.length > 0
            ) {
              question.optionsList.forEach((option) => {
                if (heading.name === option.heading) {
                  OptionList.push(option);
                }
              });
            }
          });
        }
        return OptionList;
      } else {
        return headingList;
      }
    }

    function TranslateQuestion(surveyLanguageCode, question) {
      return surveyLanguageCode !== ""
        ? question &&
          question.transl &&
          question.transl[surveyLanguageCode] &&
          question.transl[surveyLanguageCode].name
          ? question.transl[surveyLanguageCode].name
          : question.name
        : question.name;
    }

    function TranslationOptionMatrix(
      question,
      heading,
      surveyLanguageCode,
      type
    ) {
      let optionId = "";
      if (question && question.optionsList && question.optionsList.length > 0) {
        let Index = question.optionsList.findIndex(
          (prev) => prev.heading === heading
        );
        optionId = question.optionsList[Index].id;
      }
      let text =
        surveyLanguageCode !== ""
          ? question &&
            question.transl &&
            question.transl[surveyLanguageCode] &&
            question.transl[surveyLanguageCode].headingList &&
            question.transl[surveyLanguageCode].headingList[optionId]
            ? question.transl[surveyLanguageCode].headingList[optionId]
            : heading
          : heading;

      let arr = text.split("-");
      if (type === 1) {
        return arr && arr[0] ? arr[0] : text;
      }
      if (type === 2) {
        return arr && arr[0] ? arr[0] : text;
      } else if (type === 3) {
        return arr && arr[1] ? arr[1] : "";
      } else {
        return text;
      }
    }

    function TranslationStatementMatrix(question, surveyLanguageCode, type) {
      let text =
        surveyLanguageCode !== ""
          ? question &&
            question.transl &&
            question.transl[surveyLanguageCode] &&
            question.transl[surveyLanguageCode].name
            ? question.transl[surveyLanguageCode].name
            : question.name
          : question.name;

      let arr = text.split("-");
      if (type === 1) {
        return arr && arr[0] ? arr[0] : text;
      }
      if (type === 2) {
        return arr && arr[0] ? arr[0] : text;
      } else if (type === 3) {
        return arr && arr[1] ? arr[1] : "";
      } else {
        return text;
      }
    }

    let { getSurveyTemplateByCodeData } = this.props;
    function SurveyAttributes(name) {
      return surveyLanguageCode !== ""
        ? getSurveyTemplateByCodeData &&
          getSurveyTemplateByCodeData.transl &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode] &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          ? getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          : ""
        : getSurveyTemplateByCodeData && getSurveyTemplateByCodeData[name]
          ? getSurveyTemplateByCodeData[name]
          : "";
    }

    // console.log('unattemptList', this.state.unattemptList);
    // console.log('CurrQuesIndex', this.state.CurrQuesIndex);

    // console.log('answersList:===========>',answersList)

    function MandatoryMsg(Ques) {
      let Text = "";
      let Color = "";
      if (Ques.isMandatory) {
        if (Ques.templateId === 13) {
          Text = SurveyAttributes("allmandatoryText")
            ? SurveyAttributes("allmandatoryText") + "*"
            : "All questions are mandatory*";
          Color = "#eb3434";
        } else {
          Text = "*";
          Color = "#eb3434";
        }
      }
      return {
        text: Text,
        color: Color,
      };
    }

    function showNotCompletedFn(Que) {
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];
      let check = false;
      if (ShowNotAttempted) {
        let getIndex = AnswerListFinal.findIndex(
          (prev) => prev.questionId === Que.id
        );
        if (getIndex !== -1) {
          check =
            AnswerListFinal[getIndex].multiAnswer.length !== 2 ? true : false;
        }
      }

      // console.log("showNotCompletedFn===>",check)
      return check;
    }

    function CompletedCount() {
      let answerCount = 0;

      //---------------------------- basic ---------------------------------------
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];

      if (questionsList && questionsList.length > 0) {
        questionsList.forEach((ques) => {
          if (ques.templateId === 13) {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push({
                ...AnswerListFinal[getIndex],
                SubQuestionList: ques.SubQuestionList,
              });
            }
          } else {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push(AnswerListFinal[getIndex]);
            }
          }
        });
      }
      //-------------------------------------------------------------------

      if (questionsList && questionsList.length > 0) {
        questionsList.forEach((Ques) => {
          if (true) {
            //----------------latestcode ---------------------------
            let questionId = Ques && Ques.id ? Ques.id : "";
            let flag = 0;

            if (answersList && answersList.length > 0) {
              let getIndex2 = answersList.findIndex(
                (prev) => prev.questionId === questionId
              );
              if (getIndex2 !== -1) {
                let item = answersList[getIndex2];

                if (true) {
                  let template = item.template;

                  if (
                    template === 1 ||
                    template === 3 ||
                    template === 4 ||
                    template === 5 ||
                    template === 11
                  ) {
                    if (item.answer) {
                      answerCount++;
                    }
                  } else if (template === 6 || template === 16) {
                    if (Number(item.answer)) {
                      answerCount++;
                    }
                  } else if (template === 13) {
                    let isAllAnswered = 0;
                    if (
                      item &&
                      item.SubQuestionList &&
                      item.SubQuestionList.length > 0
                    ) {
                      item.SubQuestionList.forEach((subQues) => {
                        let getIndex2 = AnswerListFinal.findIndex(
                          (prev) => prev.questionId === subQues.id
                        );

                        if (item.isMandatory) {
                          if (getIndex2 !== -1) {
                            if (
                              AnswerListFinal &&
                              AnswerListFinal[getIndex2] &&
                              AnswerListFinal[getIndex2].multiAnswer &&
                              AnswerListFinal[getIndex2].multiAnswer.length > 1
                            ) {
                              isAllAnswered++;
                            }
                          }
                        } else {
                          if (getIndex2 !== -1) {
                            if (
                              AnswerListFinal &&
                              AnswerListFinal[getIndex2] &&
                              AnswerListFinal[getIndex2].multiAnswer &&
                              AnswerListFinal[getIndex2].multiAnswer.length > 0
                            ) {
                              isAllAnswered++;
                            }
                          }
                        }
                      });
                    }

                    if (
                      item.SubQuestionList.length >= isAllAnswered &&
                      isAllAnswered > 0
                    ) {
                      answerCount++;
                    }
                  } else if (template === 2) {
                    if (
                      item &&
                      item.multiAnswer &&
                      item.multiAnswer.length > 0
                    ) {
                      answerCount++;
                    }
                  } else {
                    if (item.answer) {
                      answerCount++;
                    }
                  }
                }
              }
            }
          }
        });
      }

      return answerCount;
    }

    function CompletedCountV1(list) {
      let list2 = [];
      if (list && list.length > 0) {
        list2 = list.filter((prev) => prev.answer !== "");
      }
      console.log("list2::::", list2);
      if (list2 && list2.length > 0) {
        return list2.length;
      } else {
        return 0;
      }
    }

    let answerCount = CompletedCountV1(answersList);
    console.log("answerCount::::", answerCount);

    let completedMilestone = answerCount;
    // let completedPercentage = 0;

    // if (questionsList && questionsList.length > 0) {
    //   let num = (answerCount * 100) / questionsList.length;
    //   console.log("num::::",num)

    //   completedPercentage = (answerCount * 100) / questionsList.length;
    //   if (num >= 25 && num < 50) {
    //     completedMilestone = "25%";
    //   } else if (num >= 50 && num < 75) {
    //     completedMilestone = "50%";
    //   } else if (num >= 75 && num < 100) {
    //     completedMilestone = "75%";
    //   } else if (num >= 100) {
    //     completedMilestone = "100%";
    //   }
    // }

    // let groupQuestionList = []
    // if(questionsList && questionsList.length>0){
    //   questionsList.forEach((item)=>{
    //     if(!(item && item.parentId)){
    //       groupQuestionList.push(item);
    //     }
    //   });
    // }
    //console.log("GroupQuestionOnlyList---------->",GroupQuestionOnlyList)

    function getGroupIndex(QuesId) {
      //console.log("QuesId---------->",QuesId)

      if (GroupQuestionOnlyList && GroupQuestionOnlyList.length > 0) {
        let getIndex = GroupQuestionOnlyList.findIndex(
          (prev) => prev.id === QuesId
        );
        if (getIndex !== -1) {
          //console.log("match---------->",getIndex+1)

          return (getIndex + 1).toString() + ". ";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }

    // console.log(
    //   "questionsList---------------------------------->",
    //   questionsList
    // );
    console.log("answersList--------------------- ---->", answersList);

    function functionNameVariable(quesName) {
      return quesName && quesName.toString()
        ? quesName.toString().replace("[variable]", UserRespondantName)
        : quesName;
    }

    function getSecondsToTime(given_seconds) {
      var seconds = parseInt(given_seconds);
      var format =
        (Math.floor(moment.duration(seconds, "seconds").asHours()) < 10
          ? Math.floor(moment.duration(seconds, "seconds").asHours())
          : Math.floor(moment.duration(seconds, "seconds").asHours())) +
        ":" +
        (moment.duration(seconds, "seconds").minutes() < 10
          ? "0" + moment.duration(seconds, "seconds").minutes()
          : moment.duration(seconds, "seconds").minutes()) +
        ":" +
        (moment.duration(seconds, "seconds").seconds() < 10
          ? "0" + moment.duration(seconds, "seconds").seconds()
          : moment.duration(seconds, "seconds").seconds());
      return format;
    }
    console.log("surveyLanguageCode------------>", surveyLanguageCode);




    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (getTranslateElementAllData && getTranslateElementAllData.length > 0) {
          let getIndex = getTranslateElementAllData.findIndex(prev => prev.name === name);
          if (getIndex !== -1) {
            sentence = getTranslateElementAllData && getTranslateElementAllData[getIndex] && getTranslateElementAllData[getIndex]["transl"] && getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] ? getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] : ""
          }
        }
        console.log("sentence------------>", sentence);
        console.log("surveyLanguageCode------------>", surveyLanguageCode);
        console.log("getTranslateElementAllData------------>", getTranslateElementAllData);

        return sentence ? sentence : text
      } else {
        return text
      }
    }

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = element && element["details"] && element["details"]["transl"] && element["details"]["transl"][surveyLanguageCode] && element["details"]["transl"][surveyLanguageCode][name] ?
          element["details"]["transl"][surveyLanguageCode][name] : ""
        return sentence ? sentence : text
      } else {
        return text
      }
    }


    function EditButtonFn(name, text) {
      return (
        <>
          {GetTextByLanguage(name, text)}
        </>
      )
    }
    function EditDetailsFn(element, name, text) {
      return (
        <>
          {GetDetailsByLanguage(element, name, text)}
        </>
      )
    }


    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }




    function getTheme(field, init) {
      if (themeType === 2) {

        if (field === "backgroundImage") {
          return 'url("/img/survey-light-bg.webp")'
        }
        else if (field === "welcomeImage") {
          return "url('/img/assessment-welcome-large.webp')"
        }
        else if (field === "text") {
          return '#3D405B'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "textblue") {
          return '#2196F3'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "hoverActive") {
          return 'hover:bg-[' + hexToRgbA('#2196F3', '0.12') + '] hover:border-[#2196F3] hover:text-[#2196F3] '
        }
        else if (field === "grayheader") {
          return ' bg-[' + hexToRgbA('#3D405B', '0.05') + '] '
        }
        else if (field === "textOption") {
          return 'border-[#3D405B] text-[#3D405B] '
        }
        else {
          return init
        }

      } else {
        return init
      }
    }


    function isQuesAnsComplete(answersList, quesId) {
      let count = 0;

      if (answersList && answersList.length > 0) {
        answersList.forEach((item) => {
          if (quesId.toString() === item.questionId.toString()) {

            let template = item.template;
            if (item.answer) {
            } else {
            }

            if (
              template === 1 ||
              template === 3 ||
              template === 4 ||
              template === 5 ||
              template === 6 ||
              template === 16 ||
              template === 11
            ) {
              if (item.answer) {
                count = count + 1;
              }
            } else if (template === 2) {
              if (
                (item && item.multiAnswer && item.multiAnswer.length > 0)
              ) {
                count = count + 1;
              }
            } else {
              if (item.answer) {
                count = count + 1;
              }
            }

          }

        })
      }

      return count;
    }


    function getQuesAnswer(answersList, quesId) {
      let answer = "";

      if (answersList && answersList.length > 0) {
        answersList.forEach((item) => {
          if (quesId.toString() === item.questionId.toString()) {

            let template = item.template;


            if (
              template === 1 ||
              template === 3 ||
              template === 4 ||
              template === 5 ||
              template === 6 ||
              template === 16 ||
              template === 11
            ) {
              if (item.answer) {
                answer = item.answer;
              }
            } else if (template === 2) {
              if (
                (item && item.multiAnswer && item.multiAnswer.length > 0)
              ) {
                answer = item.multiAnswer.map((ele) => (ele)).join(",");
              }
            } else {
              if (item.answer) {
                answer = item.answer;
              }
            }

          }

        })
      }

      return answer;
    }


    let pairList = getQuestionPair(questionsList);



    let categoryQuesTemp = [];
    let categoryQuestions = [];
    if (questionsList && questionsList.length > 0) {

      if (true) {


        // Function to get unique values based on a property (e.g., 'id')
        function getUniquePropertyValues(arr, prop) {
          return arr && arr.length > 0 ? arr.reduce((unique, obj) => {
            if (!unique.some(o => o[prop] === obj[prop])) {
              unique.push(obj);
            }
            return unique;
          }, []).map(obj => obj[prop]) : [];
        }

        function isQuesIdListCompleted(list, category, paraCategoryList) {


          let paralist = []
          if (paraCategoryList && paraCategoryList.length > 0) {
            paralist = paraCategoryList.filter(prev => prev.category === category).map((ele) => (ele.label));
          }

          let isCompleted = false;
          let completedLength = 0;
          if (list && list.length > 0) {
            let quesList = list.filter(prev => paralist.includes(prev && prev.parameterBucketId && prev.parameterBucketId.name ? prev.parameterBucketId.name : ""));
            if (quesList && quesList.length > 0) {

              completedLength = quesList.filter((ele) =>
              (isQuesAnsComplete(answersList, ele.id) > 0
                ? true : false)).length


              if (quesList.length === completedLength) {
                isCompleted = true
              }
            }
          }
          return isCompleted
        }



        function quesByParaList(list, category, paraCategoryList) {

          let paralist = []
          if (paraCategoryList && paraCategoryList.length > 0) {
            paralist = paraCategoryList.filter(prev => prev.category === category).map((ele) => (ele.label));
          }

          let quesListV2 = [];
          if (list && list.length > 0) {
            let quesList = list.filter(prev => paralist.includes(prev && prev.parameterBucketId && prev.parameterBucketId.name ? prev.parameterBucketId.name : ""));

            if (quesList && quesList.length > 0) {
              for (var i = 0; i < quesList.length; i++) {
                let quesData = quesList[i];
                let tempData = {
                  ...quesData,
                  "isComplete": isQuesAnsComplete(answersList, quesData.id) > 0 ? true : false
                }
                quesListV2.push(tempData)

              }
            }
          }
          return quesListV2
        }

        // Usage
        let questionsListV2 = questionsList.map((ele) => ({
          ...ele, parameterDimensionName: ele && ele.parameterDimensionId && ele.parameterDimensionId.name ? ele.parameterDimensionId.name : ""
        }))
        // let uniqueList = getUniquePropertyValues(questionsListV2, 'parameterDimensionName');
        // let new_list = getParameterCategoryData && getParameterCategoryData.length > 0 ? getParameterCategoryData : [];
        let uniqueList = getUniquePropertyValues(getParameterCategoryData, 'category');

        if (uniqueList && uniqueList.length > 0) {
          categoryQuestions = uniqueList.map((category, index) => ({
            "name": category,
            "list": quesByParaList(questionsListV2, category, getParameterCategoryData),
            "isComplete": pairComplete(pairList, CurrPairIndex, category, getParameterCategoryData)

            // "isComplete": isQuesIdListCompleted(questionsListV2, category, getParameterCategoryData)
          }))
        }



      }
    }

    function isSubset(list1, list2) {
      return list1.every(item => list2.includes(item));
    }


    function pairComplete(p_list, crrPair, category, paraCategoryList) {
      let para_list = []
      if (p_list && p_list.length > 0) {
        p_list.forEach((pairData, index) => {
          if (crrPair < index) {
            if (pairData && pairData.quesList && pairData.quesList.length > 0) {
              sortByRank(pairData.quesList).map((question, questionindex) => {
                let paraName = question.parameterBucketId.name;
                let getIndex = para_list.findIndex(prev => prev === paraName);
                if (getIndex === -1) {
                  para_list.push(paraName);
                }
              })
            }
          }
        })
      }

      let paraCatlist = []
      if (paraCategoryList && paraCategoryList.length > 0) {
        paraCatlist = paraCategoryList.filter(prev => prev.category === category).map((ele) => (ele.label));
      }

      console.log("paraCatlist---x >", paraCatlist);
      console.log("para_list---x >", para_list);
      return !isSubset(paraCatlist, para_list)
    }




    //console.log('getTalentPlusEmpStatusData--->mgetTalentPlusEmpStatusData', getTalentPlusEmpStatusData)


    function getStarterStatus(list, index) {
      let check = false;
      if (list && list.length > 0 && index > 0) {
        //console.log("list[index - 1]--->", list[index - 1])
        check = list && list[index - 1] && list[index - 1]["isComplete"] ? true : false
      } else {
        check = true
      }
      return check
    }


    let crrSectionName = ""
    if (categoryQuestions && categoryQuestions.length > 0) {
      for (var i = 0; i < categoryQuestions.length; i++) {
        let eleZ = categoryQuestions[i];
        if (!(eleZ && eleZ.isComplete) && getStarterStatus(categoryQuestions, i)) {
          crrSectionName = eleZ.name;
        }
      }
    }




    function GetParameterLabel(name) {
      let AllParameterObj = {};
      let NewParameterList = questions && questions.getParameterLibraryNameListData && questions.getParameterLibraryNameListData.length > 0 ? questions.getParameterLibraryNameListData : []
      if (NewParameterList && NewParameterList.length > 0) {
        NewParameterList.forEach((item) => {
          if (item && item.name) {
            AllParameterObj[item.name] = item && item.label ? item.label : item.name;
          }
        });
      }
      return (AllParameterObj && AllParameterObj[name] ? AllParameterObj[name] : name);
    }




    function sortByRank(quesList) {
      let newQuesList = []
      if (quesList && quesList.length > 0) {
        newQuesList = quesList.sort((a, b) => (a.rank - b.rank));
      }
      return newQuesList
    }

    function getQuesOption(pairData, type) {
      let optionList = []
      if (pairData && pairData.quesList && pairData.quesList.length > 0) {
        let quesV2List = sortByRank(pairData.quesList);
        if (quesV2List && quesV2List.length > 0) {
          let ques = quesV2List[type - 1];
          if (ques && ques.optionsList && ques.optionsList.length > 0) {
            let optionStrList = ques.optionsList;
            if (type === 1) {
              optionList = optionStrList;
            } else if (type === 2) {
              optionList = reverseFn(optionStrList);
            }
          }
        }
      }
      return optionList
    }

    function getOptScore(optName) {
      let obj = {
        "Strongly Agree": 6,
        "Agree": 5,
        "Slightly Agree": 4,
        "Slightly Disagree": 3,
        "Disagree": 2,
        "Strongly Disagree": 1
      }
      return obj && obj[optName] ? obj[optName] : ""
    }


    function getAnsOpt(optData, answerList) {
      let value = "";
      if (answerList && answerList.length > 0) {
        let getIndex = answerList.findIndex(prev => prev.questionId === optData.questionId);
        if (getIndex !== -1) {
          value = answerList[getIndex]['answer']
        }
      }
      return getOptScore(value)
    }


    console.log("answersList----<>------>", answersList);
    console.log("paraList----<>------>", pairList);

    function getBgOpacity(value) {
      let text = "";
      if (value === 1) {
        text = "bg-opacity-10"
      } else if (value === 2) {
        text = "bg-opacity-15"
      } else if (value === 3) {
        text = "bg-opacity-20"
      } else if (value === 4) {
        text = "bg-opacity-25"
      } else if (value === 5) {
        text = "bg-opacity-30"
      } else if (value === 6) {
        text = "bg-opacity-35"
      }
      return text
    }

    function getPageStatus(index, pairs) {
      return index.toString()
    }


    function boldText(text) {
      return text ? <p style={{ fontWeight: 'bold' }}>{text}</p> : text
    }


    return (
      <>


        {check === 1 ? (
          <>

            <div
              className="h-screen bg-cover bg-center w-full overflow-hidden"
              style={{
                backgroundImage: "url('https://plusinsight.happyplus.in/images//tp_survey-light-bg.webp')",

                // getTheme("backgroundImage",'url("/img/survey-bg.jpg")')
              }}
            >

              <LogoAssessmentHeader
                logout={onLogout}
                surveyScreenData={surveyScreenData}
                template={"v4"}
                details={getAssessmenrEmployeeDetailsData}
                handleReport={this.handleReport}

                surveyLanguageName={surveyLanguageName}
                handleLanguage={this.handleLanguage}
                LanguageList={LanguageList}

              />




              {/* Welcome Section */}
              {surveyStatus !== 2 && surveyStatus !== 3 ? (
                <>
                  {this.state.showWelcomeScreen &&
                    questionsList &&
                    questionsList.length > 0 ? (
                    <>
                      <div>
                        <section className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-10 py-4   flex   items-start h-[calc(100vh-5rem)]">
                          {/* right section 2 */}
                          <div className="md:flex hidden justify-center w-5/12 h-full  ">
                            <div className="bg-[#bbdefb] rounded-2xl flex justify-center items-center  w-full " style={{
                              backgroundImage: "url('https://plusinsight.happyplus.in/images//tp_assessment-welcome-large.webp')",
                              // getTheme("welcomeImage","/img/talent_assessment_intro.svg"),
                              backgroundSize: 'cover'
                            }}>

                              {themeType === 1 ?
                                <img
                                  src={getTheme("welcomeImage", "/img/talent_assessment_intro.svg")}
                                  className="2xl:w-10/12 w-11/12 mx-auto"
                                />
                                : null}

                            </div>
                          </div>

                          <div className="md:w-7/12 w-full 2xl:space-y-10  xl:space-y-8  space-y-8      ">
                            <div className="md:space-y-4 text-white text-base font-normal " style={{ color: getTheme("text", "#FFFFFF") }}>
                              <h1 className="left   font-medium xl:text-4xl text-2xl text-white/100  md:px-10 px-0 py-4  " style={{ color: getTheme("text", "#FFFFFF") }}>
                                {SurveyAttributes("welcomeToText") ? SurveyAttributes("welcomeToText") : "Welcome to "}
                                {(surveyLanguageCode !== '') ?
                                  (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].name) ? surveyScreenData.transl[surveyLanguageCode].name :
                                    " the World of Leadership Potential"
                                  : " the World of Leadership Potential"
                                  // surveytitle
                                }
                              </h1>

                              <div className="lg:h-[calc(100vh-25rem)] md:h-[calc(100vh-26rem)]  h-[calc(100vh-21rem)] overflow-y-auto custom-scroll space-y-4 md:px-10  pr-4 "
                                style={{ color: getTheme("text", "#757575") }}>


                                {(surveyLanguageCode !== '' && surveyLanguageCode !== 'en') ?
                                  <div dangerouslySetInnerHTML={{
                                    __html:
                                      functionNameVariable((surveyLanguageCode !== '') ?
                                        (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].welcomeText) ? surveyScreenData.transl[surveyLanguageCode].welcomeText : welcomeTextDislay
                                        : welcomeTextDislay)
                                  }} />
                                  :
                                  <>
                                    <p className="text-lg font-medium">Hello,</p>

                                    <p className="text-md">Every one of us has the capacity to lead in unique and impactful ways. Some people discover this early and harness their potential to inspire others and achieve remarkable things. Others may find their leadership style later in life, or sometimes feel that their potential remains unexplored, leading to a less fulfilling experience in their work and personal lives.</p>

                                    <p className="text-lg font-medium">Now, it’s easier than ever to unlock your leadership potential.</p>

                                    <p className="text-md">Our
                                      <b className="font-semibold">
                                        {" "}
                                        LeadershipPlus Assessment{" "}
                                      </b>{" "} is designed to help you uncover your inherent leadership strengths and tendencies. With just a few clicks, you can complete our scientifically crafted questionnaire across five key leadership domains: {boldText("Leading Self, Leading Others, Leading Teams, Leading Results, and Leading Community.")}

                                      By responding thoughtfully to each question, you will gain immediate insights into your unique leadership profile.</p>

                                    <p>Discover the path to a more impactful and fulfilling leadership journey today.</p>

                                    <p className="text-lg font-medium">Instructions:</p>

                                    <ul className="list-decimal  list-inside  text-md ">
                                      <li>
                                        The test will take around{" "}<b className="font-semibold">40 minutes</b>{" "} , to finish <b className="font-semibold">75 paired questions</b>.
                                      </li>
                                      {/* <li>
                                        {" "}
                                        You get{" "}
                                        <b className="font-semibold ">
                                          15 seconds
                                        </b>{" "}
                                        to respond to each question.
                                      </li> */}
                                      <li>
                                        {" "}
                                        You should respond with your{" "}
                                        <b className="font-semibold ">
                                          first thought.
                                        </b>
                                      </li>
                                      <li>
                                        {" "}
                                        It’s a{" "}
                                        <b className="font-semibold ">
                                          6-point rating scale
                                        </b>
                                        , where{" "}
                                        <b className="font-semibold ">
                                          1 is Strongly Disagree
                                        </b>{" "}
                                        and{" "}
                                        <b className="font-semibold ">
                                          6 is Strongly Agree.
                                        </b>
                                      </li>
                                      <li>
                                        {" "}
                                        There is no{" "}
                                        <b className="font-semibold ">
                                          right
                                        </b> or{" "}
                                        <b className="font-semibold ">wrong</b>{" "}
                                        answer. It is just what you feel about the
                                        statement.{" "}
                                      </li>
                                    </ul>

                                    <p className="text-md">
                                      Once done, press the submit button and click on your profile to see your result. Although the report is quite detailed and should give you a very deep insight on your leadership potential, still need a coaching call with TalentPlus Consultant is recommended. You can fix up the same by writing to us at
                                      <b> contact@happyplus.in</b>
                                    </p>

                                    <p className="block text-md">All the best.</p>
                                    <p className="text-lg font-medium">HappyPlus Assessment Team.</p>

                                  </>}

                              </div>
                            </div>

                            <div className=" w-full flex flex-col md:space-y-8 space-y-4  justify-start  md:pl-10 ">
                              <button
                                onClick={() => this.goToInstructionPage()}
                                className="md:w-80 w-full  uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden"
                              >
                                <span className="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                                {SurveyAttributes("StartAssessmentButtonText")
                                  ? SurveyAttributes("StartAssessmentButtonText")
                                  : "START ASSESSMENT"}
                              </button>

                              <div className="flex md:justify-end justify-center mb-2">
                                <p className="  text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                  © Powered by{" "}
                                  <b class="font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                    HappyPlus
                                  </b>
                                </p>
                              </div>
                            </div>
                            {/* 
                        <div className="flex md:justify-end justify-center">
                          <div className="bg-white p-2 px-3 rounded-md flex items-center space-x-2">
                            <p className="text-sm text-slate-600">
                              © Powered by
                            </p>
                            <img src="/img/newlogo1.png" className="w-20" />
                          </div>
                        </div> */}

                            {/* pragraph */}
                            {/* <div className="pb-24">
                          <div
                            id="chatbot"
                            className="cursor-default text-left mx-4 overflow-y-auto lg:px-14 "
                            style={{
                              height: "420px",
                              color:
                                surveyScreenData && surveyScreenData.textColor
                                  ? surveyScreenData.textColor
                                  : "black",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: functionNameVariable(
                                surveyLanguageCode !== ""
                                  ? surveyScreenData &&
                                    surveyScreenData.transl &&
                                    surveyScreenData.transl[
                                      surveyLanguageCode
                                    ] &&
                                    surveyScreenData.transl[surveyLanguageCode]
                                      .welcomeText
                                    ? surveyScreenData.transl[
                                        surveyLanguageCode
                                      ].welcomeText
                                    : welcomeTextDislay
                                  : welcomeTextDislay
                              ),
                            }}
                          />
                        </div> */}
                          </div>

                          {/*  */}
                        </section>
                      </div>
                    </>
                  ) : null}

                  {/* Instruction Section */}

                  {this.state.instructionPage ? (
                    <>
                      <div>
                        <section className="lg:w-5/6 md:py-6 py-4 mx-auto lg:px-0 md:px-6 px-2 " style={{ height: "75%" }}>
                          <div className="flex justify-center -mt-4"></div>
                          <p
                            style={{
                              color:
                                surveyScreenData && surveyScreenData.textColor
                                  ? surveyScreenData.textColor
                                  : "black",
                            }}
                            className="text-center py-2 font-bold text-2xl"
                          >
                            {LabelObj &&
                              LabelObj[surveyLanguageCode] &&
                              LabelObj[surveyLanguageCode].InstructionLabelText
                              ? LabelObj[surveyLanguageCode]
                                .InstructionLabelText
                              : SurveyAttributes("instructionLabel")
                                ? SurveyAttributes("instructionLabel")
                                : "Instructions"}
                          </p>
                          <div className="pb-24">
                            <div
                              id="chatbot"
                              className="cursor-default mx-4 mt-2 overflow-y-auto lg:px-14 lg:pl-32 lg:pr-4"
                              style={{
                                height: "400px",
                                color:
                                  surveyScreenData && surveyScreenData.textColor
                                    ? surveyScreenData.textColor
                                    : "black",
                              }}
                              dangerouslySetInnerHTML={{
                                __html:
                                  surveyLanguageCode !== ""
                                    ? surveyScreenData &&
                                      surveyScreenData.transl &&
                                      surveyScreenData.transl[
                                      surveyLanguageCode
                                      ] &&
                                      surveyScreenData.transl[
                                        surveyLanguageCode
                                      ].instructionText
                                      ? surveyScreenData.transl[
                                        surveyLanguageCode
                                      ].instructionText
                                      : instructionTextDislay
                                    : instructionTextDislay,
                              }}
                            />
                          </div>
                          <div className=" flex  justify-center ">
                            <div>
                              <button
                                onClick={() => this.goToQuestionPage()}
                                className="w-80  uppercase text-xl font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden"
                              >
                                {SurveyAttributes("ContinueButtonText")
                                  ? SurveyAttributes("ContinueButtonText")
                                  : "Continue"}
                              </button>
                              <p
                                style={{
                                  backgroundColor:
                                    bgType === 1 || afterSubmitData.bgType === 1
                                      ? bgColor
                                        ? bgColor
                                        : afterSubmitData.bgColor
                                          ? afterSubmitData.bgColor
                                          : "#757575"
                                      : "#f1f1f1",
                                }}
                                className="text-sm py-4 pl-6"
                              >
                                {" "}
                                © Powered by{" "}
                                <b className="font-semibold">happyPlus</b>
                              </p>
                            </div>
                          </div>
                          {/*  */}
                        </section>
                      </div>
                    </>
                  ) : null}

                  {/* ==========> Question Section =======================================================*/}

                  {(this.state.showQuestionScreen && !this.state.submitSucces) ? (
                    <div>
                      {/* steps */}
                      <div className="bg-[#1976D2]  ">
                        {/* laptop view */}
                        <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 p-4  justify-start space-x-10 lg:flex hidden">
                          <button className="bg-[#fff]/10 rounded-full p-2.5 text-white">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left"
                            >
                              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                              <path d="M5 12l14 0" />
                              <path d="M5 12l6 6" />
                              <path d="M5 12l6 -6" />
                            </svg>
                          </button>
                          {/* steps circle */}
                          <div className="flex items-center space-x-3">
                            {/* 1 */}


                            {categoryQuestions && categoryQuestions.length > 0 ?
                              categoryQuestions.map((eleZ, indexx) =>
                                <>
                                  {eleZ && eleZ.isComplete ?
                                    <>
                                      <div className="flex items-center space-x-3  uppercase">
                                        <div className="bg-white w-7 h-7 rounded-full flex justify-center items-center text-[#1976D2]">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l5 5l10 -10" /></svg>

                                        </div>
                                        <span className="text-white font-medium">{eleZ && eleZ.name ? "LEADING " + eleZ.name : ""}</span>

                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={30}
                                          height={30}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-right text-white"
                                        >
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M7 7l5 5l-5 5" />
                                          <path d="M13 7l5 5l-5 5" />
                                        </svg>

                                      </div>

                                    </>

                                    :

                                    <>
                                      <div className="flex items-center space-x-3  uppercase">
                                        <div className="border-2 border-white w-7 h-7 rounded-full flex justify-center items-center text-[#1976D2]">
                                        </div>
                                        <span className="text-white font-medium">{eleZ && eleZ.name ? "LEADING " + eleZ.name : ""}</span>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={30}
                                          height={30}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-right text-white"
                                        >
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M7 7l5 5l-5 5" />
                                          <path d="M13 7l5 5l-5 5" />
                                        </svg>
                                      </div>

                                    </>

                                  }
                                </>
                              ) : null}

                          </div>
                        </div>

                        {/* mobile view */}
                        <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 p-4 flex justify-between  space-x-10 lg:hidden">

                          <div className="flex items-center space-x-4">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left text-white"
                            >
                              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                              <path d="M5 12l14 0" />
                              <path d="M5 12l6 6" />
                              <path d="M5 12l6 -6" />
                            </svg>

                            <span className="text-white font-semibold text-lg">{getLastLabel(categoryQuestions)}</span>
                          </div>

                          {/* steps circle */}
                          {!isMobile ?
                            <div className="flex items-center space-x-3">
                              {/* 1 */}
                              <div className="flex items-center space-x-3  uppercase">
                                <div className="bg-white w-7 h-7 rounded-full flex justify-center items-center text-[#1976D2]">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l5 5l10 -10" /></svg>
                                </div>
                                <div className="border-2 border-white w-7 h-7 rounded-full flex justify-center items-center text-[#1976D2]">
                                </div>
                                <div className="border-2 border-white w-7 h-7 rounded-full flex justify-center items-center text-[#1976D2]">
                                </div>
                                <div className="border-2 border-white w-7 h-7 rounded-full flex justify-center items-center text-[#1976D2]">
                                </div>
                                <div className="border-2 border-white w-7 h-7 rounded-full flex justify-center items-center text-[#1976D2]">
                                </div>
                              </div>
                            </div>
                            : null
                          }


                        </div>

                      </div>

                      <div>

                        <div className=" py-2  w-full flex items-center   bg-[rgba(61,64,91,0.05)] ">
                          <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4  flex md:flex-row flex-col-reverse md:items-center md:justify-between ">
                            <div className="flex items-center md:justify-start justify-center  space-x-4 text-white md:border-none border-t  md:pt-0 pt-2">
                              <span
                                className="material-symbols-outlined md:text-[1.5rem] text-[1.5rem]"
                                style={{ color: "rgb(61, 64, 91)" }}
                              >
                                tips_and_updates
                              </span>
                              <p
                                className="md:text-base font-medium text-sm  "
                                style={{ color: "rgb(61, 64, 91)" }}
                              >
                                {SurveyAttributes("Kindly answer the given question")
                                  ? SurveyAttributes("Kindly answer the given question")
                                  : "Kindly answer the given question"}
                              </p>
                            </div>

                            <div className="flex items-center md:pb-0 pb-2">

                              <div className="flex items-center  space-x-2 text-[#3D405B] md:w-auto w-full">
                                <span className="material-symbols-outlined md:text-[2rem] text-[1.5rem]">
                                  check_circle
                                </span>
                                {!isMobile ?
                                  <p className="md:text-lg text-base  ">{SurveyAttributes("Progress")
                                    ? SurveyAttributes("Progress")
                                    : "Progress"}</p> : null}
                                <h1 className=" font-semibold md:text-lg text-sm  ">
                                  {(CurrPairIndex) + " "}<b className="font-semibold text-[#3D405B]/60 ">{" "}
                                    /{" "}
                                    {pairList && pairList.length > 0
                                      ? pairList.length
                                      : 0}</b>
                                </h1>
                              </div>

                              {/* <div className="flex items-center  text-[#3D405B] pl-6 md:w-auto w-full">
                                <div className="flex items-center space-x-2   ">
                                  <span className="material-symbols-outlined md:text-[2rem] text-[1.5rem]">
                                    schedule
                                  </span>
                                  <p className="md:text-lg text-sm  ">{SurveyAttributes("Remaining")
                                    ? SurveyAttributes("Remaining")
                                    : "Remaining"}</p>
                                </div>
                                <h1 className=" font-semibold md:text-lg text-sm p-2 ">{getSecondsToTime(timeCounter)}</h1>
                              </div> */}
                            </div>
                          </div>
                        </div>

                        <section className="2xl:mt-24 xl:mt-24 lg:mt-12 md:mt-12 mt-4  2xl:w-3/6 xl:w-4/6 lg:w-5/6 w-full md:py-2 py-4 mx-auto lg:px-0 md:px-6 px-2 overflow-y-hidden overflow-x-hidden flex h-[calc(100vh-14rem)] ">
                          <div className="w-full" >

                            {/* Desktop View Rating design in both side*/}




                            <TransitionGroup>
                              {pairList && pairList.length > 0
                                ? pairList.map((pairData, pairIndex) =>
                                  pairIndex + 1 === CurrPairIndex ? (
                                    <CSSTransition
                                      timeout={350}
                                      classNames={this.state.changeType}
                                      key={pairIndex}
                                    >
                                      <>
                                        <section className="p-3 w-full">
                                          <div className="flex flex-col items-center w-full">

                                            <div className="flex justify-between w-full mb-2 md:px-7 px-0">
                                              <p className="text-left text-sm font-medium w-1/2 pr-4">Strongly describe me</p>
                                              <p className="text-right text-sm font-medium w-1/2 pl-4">Strongly describe me</p>
                                            </div>



                                            <div className="flex items-center justify-center border border-black overflow-hidden">




                                              {getQuesOption(pairData, 1).map((opt) => (
                                                <div onClick={() => this.onSelectOption(opt, pairList, pairIndex)} key={`left-${getOptScore(opt.name)}`} className={"md:p-2 p-1 border-r border-black bg-[#212121] " + getBgOpacity(getOptScore(opt.name))}>
                                                  <span
                                                    className={`md:w-12 md:h-12 w-5 h-5 flex items-center justify-center rounded-full ${getOptScore(opt.name) === getAnsOpt(opt, answersList)
                                                      ? 'bg-[#2196F3] text-white font-semibold border-2 border-white'
                                                      : 'bg-gray-100 text-gray-800 font-semibold'
                                                      }`}
                                                  >
                                                    {getOptScore(opt.name)}
                                                  </span>
                                                </div>
                                              ))}


                                              <div className="md:p-2 p-1 bg-white border-r border-black">
                                                <span className="md:w-12 md:h-12 w-5 h-5 flex items-center justify-center rounded-full text-black font-semibold"></span>
                                              </div>


                                              {getQuesOption(pairData, 2).map((opt) => (
                                                <div onClick={() => this.onSelectOption(opt, pairList, pairIndex)} key={`right-${getOptScore(opt.name)}`} className={"md:p-2 p-1 border-r last:border-r-0 border-black bg-[#212121] " + getBgOpacity(getOptScore(opt.name))}>
                                                  <span
                                                    className={`md:w-12 md:h-12 w-5 h-5 flex items-center justify-center rounded-full ${getOptScore(opt.name) === getAnsOpt(opt, answersList)
                                                      ? 'bg-[#2196F3] text-white font-semibold border-2 border-white'
                                                      : 'bg-gray-100 text-gray-800 font-semibold'
                                                      }`}>
                                                    {getOptScore(opt.name)}
                                                  </span>
                                                </div>
                                              ))}
                                            </div>


                                            <div className="flex justify-between w-full mt-6 md:px-7 px-0">
                                              {pairData && pairData.quesList && pairData.quesList.length > 0 ?
                                                sortByRank(pairData.quesList).map((question, questionindex) =>
                                                  <>
                                                    {questionindex === 0 ?
                                                      <p className="text-left md:text-lg text-base font-medium w-1/2 pr-4">{question.name}</p>
                                                      : null}
                                                    {questionindex === 1 ?
                                                      <p className="text-right md:text-lg text-base font-medium w-1/2 pl-4">{question.name}</p>
                                                      : null}
                                                  </>
                                                ) : null}
                                            </div>


                                            <div className="flex justify-center mt-6">
                                              {pairList && pairList.length > 0 ? (
                                                pairList.length !== CurrPairIndex ? (
                                                  <button
                                                    onClick={() => this.nextPairQues(pairList)}
                                                    className="z-40 md:w-80 w-60  uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden "
                                                  >
                                                    <span className=" bg-white rounded-full opacity-10"></span>
                                                    Next
                                                  </button>
                                                ) :
                                                  <>
                                                    <button
                                                      onClick={() => this.submitPairQues(pairList)}
                                                      className="z-40 md:w-80 w-60  uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden "
                                                    >
                                                      <span className=" bg-white rounded-full opacity-10"></span>
                                                      Submit
                                                    </button>
                                                  </>
                                              ) : null}
                                            </div>


                                          </div>
                                        </section>
                                      </>
                                    </CSSTransition>
                                  ) : null
                                )
                                : null}
                            </TransitionGroup>

                            <div className="fixed bottom-0  left-0 w-full">
                              <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                                <div className="w-full flex justify-end">
                                  <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                                    <div className="flex md:justify-end justify-center  w-full">
                                      <p className="text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                        © Powered by
                                        <b className="ml-1 font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                          HappyPlus
                                        </b>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </div>
                        </section>
                      </div>


                    </div>
                  ) : null}

                  {this.state.showThankyouScreen ? (
                    <>
                      <div className="h-[calc(100vh-8rem)] flex items-center justify-center">
                        <section className="2xl:w-8/12 xl:w-10/12 mx-auto xl:px-0 px-6 w-full py-10   flex md:space-x-10  items-start  ">
                          <div className=" lg:w-4/6 w-full mx-auto space-y-10 md:px-10   text-center">
                            <div className="space-y-4 text-white/80 text-base font-normal ">
                              <div className="flex flex-col justify-center items-center md:space-y-10 space-y-6">
                                <div className="md:w-[12rem] w-[10rem] md:h-[12rem] h-[10rem] rounded-full bg-white/10 flex justify-center items-center"
                                  style={{ background: getTheme('lightblue', hexToRgbA('#FFFFFF', '0.10')) }}>
                                  <div style={{ background: getTheme('textblue', hexToRgbA('#FFFFFF', '0.10')) }} className="md:w-[10rem] w-[8rem] h-[8rem] md:h-[10rem] rounded-full bg-white/20 flex justify-center items-center">
                                    <span className="material-icons md:text-[4.5rem] text-[4rem] text-white">
                                      thumb_up
                                    </span>
                                  </div>
                                </div>
                                <h1 className="lg:text-5xl md:text-4xl text-3xl font-bold text-white" style={{ color: getTheme('text', '#FFFFFF') }}>
                                  Thank You!
                                </h1>
                              </div>

                              <h1 className="  py-2 font-normal md:text-2xl text-xl text-white/100  " style={{ color: getTheme('text', '#FFFFFF') }}>
                                For taking the assessment survey, your report
                                will be generated soon. You can check your
                                report after 5 minutes in the profile section.
                              </h1>
                            </div>

                            {showViewReportThankYouButton && false ?
                              <div className=" w-full flex  justify-center ">
                                <button
                                  onClick={() => this.handleReport(2)}
                                  className="md:w-80 w-full  uppercase text-lg font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden  "
                                >
                                  <span class="material-icons-outlined mr-2 text-[1.5rem]">
                                    assignment
                                  </span>
                                  <span className="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                                  {"View Report"}
                                </button>
                              </div>
                              :
                              null}


                            <div className="fixed bottom-0  left-0 w-full">
                              <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                                <div className="w-full flex justify-end">
                                  <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                                    <div className="flex md:justify-end justify-center  w-full">
                                      <p className="text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                        © Powered by
                                        <b className="ml-1 font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                          HappyPlus
                                        </b>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/*  */}
                        </section>
                      </div>
                    </>
                  ) : null}
                </>
              ) : null}

              {(surveyStatus === 2 &&
                !(questionsList && questionsList.length > 0)) ||
                this.state.alreadySubmitted ? ( //already done
                <div className="">
                  <section className="xl:w-3/6 lg:w-4/6  py-6 mx-auto lg:px-0 md:px-6 px-6 ">
                    <div className="flex justify-center pb-16 mt-12">
                      {/* {(surveyScreenData && surveyScreenData.logo) ? 
                          <img alt="newlogo" style={{height:"70px"}}
                          src={surveyScreenData.logo }
                          />
                          :(afterSubmitData.logo)?
                          <img alt="newlogo" style={{height:"70px"}}
                          src={afterSubmitData.logo }/>
                        :
                        null
                        }                           */}
                    </div>
                    <div className="flex items-center h-full justify-center">
                      <div className="text-center text-white">
                        <div className="flex justify-center pb-8">
                          <img
                            alt="pic"
                            src="pictures/surveydone.png"
                            className="md:w-auto w-6/6 "
                          />
                        </div>
                        <h1
                          className="font-bold text-gray-800 md:text-4xl text-3xl tracking-widest leading_lose leading-10"
                          style={{}}
                        >
                          <div
                            style={{
                              textAlign: "center",
                              color:
                                surveyScreenData && surveyScreenData.textColor
                                  ? surveyScreenData.textColor
                                  : "black",
                            }}
                            dangerouslySetInnerHTML={{
                              __html:
                                // LabelObj && LabelObj[surveyLanguageCode] && LabelObj[surveyLanguageCode].SurveyAlreadyDoneText?
                                // '<h1>'+LabelObj[surveyLanguageCode].SurveyAlreadyDoneText+'</h1>':"<h1>Survey Is Already Submitted !</h1>"

                                SurveyAttributes("AlreadyText")
                                  ? "<h1>" +
                                  SurveyAttributes("AlreadyText") +
                                  "</h1>"
                                  : "<h1>Survey Is Already Submitted !</h1>",
                            }}
                          />
                        </h1>
                        <p className="text-xl opacity-80 font-light py-2"></p>
                      </div>
                    </div>
                  </section>

                  {/* {LanguageList && LanguageList.length>0?
                      <div className="flex items-center h-full justify-center">
                      <div className="relative inline-flex mb-4 ">
                          <svg className="w-2 h-2 absolute top-0 right-0 m-4 pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 412 232"><path d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z" fill="#648299" fill-rule="nonzero"/></svg>
                          <select onChange={(e)=>this.handleLanguage(e)} className="border border-gray-300 rounded-full text-gray-600 h-10 pl-5 pr-10 bg-white hover:border-gray-400 focus:outline-none appearance-none">
                            <option value={"en"}>English</option>
                            {LanguageList && LanguageList.length>0?
                              LanguageList.map((item,index)=>
                                <option keys={index} value={item.shortName}>{item.name}</option>
                              )
                            :null}
                          </select>
                        </div> 
                      </div>
                      :null} */}

                  {/* powered by logo */}
                  {/* <div 
                                                                            style={{
                                                                              height: '10%',
                                                                              backgroundColor:(bgType===1 || afterSubmitData.bgType===1)? (bgColor) ? bgColor : (afterSubmitData.bgColor)?afterSubmitData.bgColor: "#757575"    :"#f1f1f1",
                                                                              backgroundImage:(bgType===2 || afterSubmitData.bgType===2)? (bgImage) ? bgImage : (afterSubmitData.bgImage)?afterSubmitData.bgImage: null   :null,
                                                                            }}
                      className="fixed flex lg:bottom-4 bottom-0 lg:right-4 lg:w-auto w-full lg:border-none border-t border-tran bg-green-768" > 
                        <div className="lg:mx-0 mx-auto lg:py-8 md:py-4 py-4 ">
                          <div className="flex items-center"> <p className="text-gray-600 text-sm font-light" style={{color:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor:'black'}}>© Powered by <b className="font-semibold">HappyPlus</b></p> </div>
                        </div>
                      </div> */}

                  <div
                    style={{
                      height: "10%",
                      backgroundColor:
                        bgType === 1 || afterSubmitData.bgType === 1
                          ? bgColor
                            ? bgColor
                            : afterSubmitData.bgColor
                              ? afterSubmitData.bgColor
                              : "#757575"
                          : "#f1f1f1",
                      backgroundImage:
                        bgType === 2 || afterSubmitData.bgType === 2
                          ? bgImage
                            ? bgImage
                            : afterSubmitData.bgImage
                              ? afterSubmitData.bgImage
                              : null
                          : null,
                    }}
                    className="fixed bottom-6  left-0 w-full flex  justify-center bg-white bg-opacity-100"
                  >
                    <p
                      className="text-sm py-4"
                      style={{ color: getTheme("text", "#FFFFFF") }}
                    >
                      {" "}
                      © Powered by <b className="font-semibold">happyPlus</b>
                    </p>
                  </div>
                </div>
              ) : null}

              {/* survey expired page ----------------------------------------------------------------------------------------------- */}

              {surveyStatus === 3 &&
                !(questionsList && questionsList.length > 0) ? ( //expired
                <div>
                  <section className="lg:w-4/6   mx-auto lg:px-0 md:px-6 px-2 flex items-center py-32 justify-center overflow-y-hidden">
                    {/* logo */}
                    <div>
                      <div className="flex justify-center">
                        <img src="img/expiry.png" className="w-32" />
                      </div>
                      <div className="flex items-center h-full justify-center">
                        <div
                          className="text-center font-bold text-2xl mt-6"
                          style={{
                            textAlign: "center",
                            color:
                              surveyScreenData && surveyScreenData.textColor
                                ? surveyScreenData.textColor
                                : "black",
                          }}
                          dangerouslySetInnerHTML={{
                            __html:
                              // LabelObj && LabelObj[surveyLanguageCode] && LabelObj[surveyLanguageCode].SurveyExpiredText? '<h1>' + LabelObj[surveyLanguageCode].SurveyExpiredText+'</h1>':"<h1>This Survey is <br>Expired!</h1>"

                              SurveyAttributes("ExpiryText")
                                ? "<h1>" +
                                SurveyAttributes("ExpiryText") +
                                "</h1>"
                                : "<h1>This Survey is <br>Expired!</h1>",
                          }}
                        />
                      </div>
                    </div>
                  </section>
                  {/* <div className="fixed bottom-6  left-0 w-full flex  justify-center bg-white bg-opacity-100">
                    <p className="text-sm py-4"> © Powered by <b className="font-semibold">happyPlus</b></p>
                  </div> */}

                  <div
                    style={{
                      height: "10%",
                      backgroundColor:
                        bgType === 1 || afterSubmitData.bgType === 1
                          ? bgColor
                            ? bgColor
                            : afterSubmitData.bgColor
                              ? afterSubmitData.bgColor
                              : "#757575"
                          : "#f1f1f1",
                      backgroundImage:
                        bgType === 2 || afterSubmitData.bgType === 2
                          ? bgImage
                            ? bgImage
                            : afterSubmitData.bgImage
                              ? afterSubmitData.bgImage
                              : null
                          : null,
                    }}
                    className="fixed bottom-6  left-0 w-full flex  justify-center bg-white bg-opacity-100"
                  >
                    <p
                      className="text-sm py-4"
                      style={{ color: getTheme("text", "#FFFFFF") }}
                    >
                      {" "}
                      © Powered by <b className="font-semibold">happyPlus</b>
                    </p>
                  </div>
                </div>
              ) : null}

            </div>


          </>
        ) : null}

        {check === 2 ? (
          <>

            <div
              className="h-screen bg-cover bg-center w-full overflow-hidden"
              style={{
                backgroundImage: "url('https://plusinsight.happyplus.in/images//tp_survey-light-bg.webp')",

                // getTheme("backgroundImage",'url("/img/survey-bg.jpg")')
              }}
            >

              <LogoAssessmentHeader
                logout={onLogout}
                surveyScreenData={surveyScreenData}
                template={"v4"}
                details={getAssessmenrEmployeeDetailsData}
                handleReport={this.handleReport}

                surveyLanguageName={surveyLanguageName}
                handleLanguage={this.handleLanguage}
                LanguageList={LanguageList}

              />

              <div className="h-[calc(100vh-8rem)] flex items-center justify-center">
                <section className="2xl:w-8/12 xl:w-10/12 mx-auto xl:px-0 px-6 w-full py-10   flex md:space-x-10  items-start  ">
                  <div className=" lg:w-4/6 w-full mx-auto space-y-10 md:px-10   text-center">
                    <div className="space-y-4 text-white/80 text-base font-normal ">
                      <div className="flex flex-col justify-center items-center md:space-y-10 space-y-6">
                        <div className="md:w-[12rem] w-[10rem] md:h-[12rem] h-[10rem] rounded-full bg-white/10 flex justify-center items-center"
                          style={{ background: getTheme('lightblue', hexToRgbA('#FFFFFF', '0.10')) }}>
                          <div style={{ background: getTheme('textblue', hexToRgbA('#FFFFFF', '0.10')) }} className="md:w-[10rem] w-[8rem] h-[8rem] md:h-[10rem] rounded-full bg-white/20 flex justify-center items-center">
                            <span className="material-icons md:text-[4.5rem] text-[4rem] text-white">
                              thumb_up
                            </span>
                          </div>
                        </div>
                        <h1 className="lg:text-4xl md:text-3xl text-2xl font-bold text-white" style={{ color: getTheme('text', '#FFFFFF') }}>
                          Assessment already submitted!
                        </h1>
                      </div>

                      {/* <h1 className="  py-2 font-normal md:text-2xl text-xl text-white/100  " style={{ color: getTheme('text', '#FFFFFF') }}>
                      For taking the assessment survey, your report
                      will be generated soon. You can check your
                      report after 5 minutes in the profile section.
                    </h1> */}
                    </div>

                    <div className="fixed bottom-0  left-0 w-full">
                      <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                        <div className="w-full flex justify-end">
                          <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                            <div className="flex md:justify-end justify-center  w-full">
                              <p className="text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                © Powered by
                                <b className="ml-1 font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                  HappyPlus
                                </b>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*  */}
                </section>
              </div>
            </div>
          </>
        ) : null}

        {showLeaderReportModal &&
          <LeadershipReport
            getLeadershipReportScoreData={getLeadershipReportScore_USERData}
            getLeadershipTextDetailsData={getLeadershipTextDetails_USERData}
            getLeadershipParaCategoryData={getLeadershipParaCategory_USERData}
            closeReportModal={this.closeLeaderReportModal}
            getTranslateElementAllData={getTranslateElementAllData}
            getAnsweredEmployeesData={{}}
            getLanguageData={{}}
            GetParameterLabel={GetParameterLabel}
            crrCodeUserDetails={this.state.crrCodeUserDetails}

          />
        }


        {/* 
        {showReportModal ? (
          <AssessmentReport
            closeReportModal={this.closeReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            onAssessmentByEmpID={this.onAssessmentByEmpID}
            getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
            createdAt={createdAt}

            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
            handleDownloadStatus={this.handleDownloadStatus}
          />
        ) : null}


        {showSummaryReport ? (
          <AssessmentSummary
            closeReportModal={this.closeSummaryReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            onAssessmentByEmpID={this.onAssessmentByEmpID}
            getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
            createdAt={createdAt}

            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
            handleDownloadStatus={this.handleDownloadStatus}
          />
        ) : null} */}



      </>
    );
  }
}
QuestionPublish.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users } = state;
  return {
    loggingIn,
    questions,
    users,
  };
}

export default connect(mapStateToProps)(QuestionPublish);
